import React, { useRef } from 'react';
import Countdown, { zeroPad } from 'react-countdown';
import './countdown.css';
import { getCleanTime } from '../../utils';

const CountdownTimer = ({ force, purposedTime, endMessage, onComplete = () => {}, setCountDown }) => {
  const EndMessage = () => <div className="countdown">{endMessage}</div>;
  const startCountdown = useRef(false);
  const stopCountdown = useRef(false);
  const timeObj = getCleanTime(purposedTime);
  const timeString = `${timeObj.date} ${timeObj.month.substring(0, 3)}, ${timeObj.day.toUpperCase()}, ${timeObj.hour}:${
    timeObj.minute
  } ${timeObj.ampm} ONWARDS `;
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setTimeout(() => onComplete(), 0);
      if (stopCountdown.current === false) {
        setCountDown(false);
        stopCountdown.current = true;
      }
      return <EndMessage />;
    } else {
      if (startCountdown.current === false) {
        setCountDown(true);
        startCountdown.current = true;
      }
      return (
        <div className="countdownOuter">
          <div className="eventDetail">{timeString}</div>
          <div className="countInner">
            <div className="countMsg">TIME REMAINING</div>
            <div className="countdown">
              <div className="countHR">
                <p>{zeroPad(hours)}</p> <span>Hrs</span>
              </div>
              <div className="countDivider">:</div>
              <div className="countMin">
                <p>{zeroPad(minutes)}</p> <span>Mins</span>
              </div>
              <div className="countDivider">:</div>
              <div className="countSec">
                <p>{zeroPad(seconds)}</p> <span>Secs</span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };
  return <Countdown date={purposedTime} renderer={renderer} zeroPadTime={3} />;
};

export default CountdownTimer;
